/**
 * MediKaLLink doctor unread messages API (GET).
 *
 * TODO: Always obtain `bearerToken` from the host app session / widget credential helper
 * (`getMedicalLinkCredentialsFromSession` + `VoiceNavWidget` config merge) — do not hardcode
 * tokens in callsites; pass through from `getMedicalLinkCredentialsForApi()` only.
 */

import { getUnreadMessagesUrl } from './apiConfig'

export type GetUnreadMessagesCredentials = {
  bearerToken: string
  /** Optional; MediKaLLink may require non-empty CSRF in some deployments. */
  csrfToken?: string
}

export { getUnreadMessagesUrl }

/**
 * Fetches raw JSON from the unread-messages GET endpoint (see VoiceNav catalog → `medicalLink.rest.doctorGetUnreadMessages`).
 * Caller maps with `mapUnreadMessagesResponse` (defensive shapes).
 */
export async function getUnreadMessages(
  creds: GetUnreadMessagesCredentials,
  urgent: 0 | 1 = 0,
): Promise<unknown> {
  const token = (creds.bearerToken || '').trim()
  if (!token) {
    throw new Error('Missing MediKaLLink bearer token for unread messages.')
  }
  const url = getUnreadMessagesUrl(urgent)
  const res = await fetch(url, {
    method: 'GET',
    headers: {
      accept: '*/*',
      Authorization: `Bearer ${token}`,
      'X-CSRF-TOKEN': (creds.csrfToken ?? '').trim(),
    },
  })
  const raw = await res.text().catch(() => '')
  console.debug('[VoiceNav] unread messages API response meta', {
    url,
    urgent,
    status: res.status,
  })
  console.debug(`[VoiceNav] unread messages API response body:\n${raw}`)
  if (!res.ok) {
    throw new Error(`Unread messages HTTP ${res.status}${raw ? `: ${raw.slice(0, 200)}` : ''}`)
  }
  try {
    const parsed = raw ? JSON.parse(raw) : {}
    console.debug('[VoiceNav] unread messages API parsed JSON', parsed)
    return parsed
  } catch {
    throw new Error(`Unread messages returned invalid JSON${raw ? `: ${raw.slice(0, 200)}` : ''}`)
  }
}
